{
  "title": "Patrimonio neto",
  "table": "Tabla",
  "chart": "Gráfico de barras",
  "accordion": "Acordeón",
  "assets": "Activos",
  "liabilities": "Pasivos",
  "currentNetWorth": "Patrimonio neto actual",
  "downloadProgressTitle": "Datos sobre el patrimonio neto del paquete",
  "lastUpdated": "Última actualización",
  "accountSourceType": {
    "INTERNAL": "INTERNO",
    "EXTERNAL": "EXTERNO"
  },
  "categories": {
    "INTERNAL": "Inversiones internas",
    "CASH": "Efectivo",
    "EXTERNAL_INVESTMENT_ACCOUNT": "Inversiones externas",
    "REAL_ESTATE": "Bienes raíces",
    "VEHICLES": "Vehículos",
    "VALUABLES": "Objetos de valor",
    "OTHER_ASSET": "Otros",
    "LOANS": "Préstamos",
    "MORTGAGE": "Hipoteca",
    "CREDIT_CARD": "Tarjeta de crédito",
    "OTHER_LIABILITY": "Otros"
  },
  "netWorthTable": {
    "financialAccounts": "Cuentas financieras",
    "asset": "Activo",
    "liability": "Pasivo",
    "noNetWorthData": "No hay información sobre el patrimonio neto",
    "total": "Total:",
    "downloadColumns": {
      "accountId": "ID de cuenta",
      "firstName": "Nombre del usuario",
      "lastName": "Apellido del usuario",
      "entityName": "Nombre de la entidad",
      "accountType": "Tipo de cuenta",
      "accountNickname": "Nombre de usuario de la cuenta",
      "value": "Valor",
      "source": "Fuente",
      "category": "Categoría",
      "organization": "Organización",
      "user": "Usuario"
    }
  },
  "editNetWorth": {
    "title": "Editar un activo o un pasivo",
    "type": "Tipo",
    "accountNickname": "Nombre de usuario de la cuenta",
    "value": "Valor",
    "delete": "Eliminar",
    "save": "Guardar",
    "deleteConfirmation": {
      "title": "¿Eliminar la cuenta {{accountName}}?",
      "bodyText": "¿Está seguro(a) de que desea eliminar este elemento?"
    }
  },
  "netWorthAccordion": {
    "noNetWorthData": "No hay información sobre el patrimonio neto"
  },
  "netWorthChart": {
    "emptyChart": "No hay información"
  },
  "addNetWorthManually": {
    "title": "Añadir cuenta manual",
    "nickname": "Nombre de usuario",
    "value": "Valor",
    "currency": "Moneda",
    "currencies": {
      "USD": "Dólar estadounidense",
      "CAD": "Dólar canadiense"
    }
  },
  "addNetWorthAutomatically": {
    "linkingTimeInfo": "La conexión puede tardar hasta 5 minutos...",
    "noIntegration": "No se encontró ninguna integración",
    "linkSuccess": "Vinculación exitosa",
    "linkError": "Error al establecer la vinculación",
    "netWorthAutomaticLink": {
      "title": "Patrimonio neto de la vinculación",
      "syncMessage": "Sus cuentas se están sincronizando.",
      "notificationMessage": "Le notificaremos una vez que estén listas.",
      "notificationSuccessTitle": "Cuentas Plaid sincronizadas.",
      "notificationSuccessBody": "Su patrimonio neto está al día.",
      "notificationFailureTitle": "Error al sincronizar las cuentas Plaid.",
      "notificationFailureBody": "Inténtelo de nuevo.",
      "notificationLinkText": "Gracias"
    }
  }
}
